
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import GroupeForm from '@/components/forms/GroupeForm.vue'

const groupeModule = namespace('groupe')

@Component({
  components: {
    BaseCardContainer,
    GroupeForm
  }
})
export default class GroupeCreate extends Vue {
  @groupeModule.Action('createGroupeAction') createGroupe: any
  @groupeModule.Action('getGroupesAction') getGroupes: any

  mounted() {
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  onSubmit(data: any) {
    this.createGroupe(data).then(async (data: any) => {
      this.getGroupes()
      this.$router.push({name: 'groupeList'})
    })
  }

  onCancel() {
    this.$router.replace({name: 'groupeList'})
  }
}
